import React from 'react';
import { Flow } from 'flow-react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import Modal from 'components/UI/Modal/Modal';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ConfigTypes from 'config/ConfigTypes';

import './CartMessage.scss'

const CartMessage = observer(
    class CartMessage extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                modalOpened: false,
                cartMessage: ""
            }
        }

        initData = (prevProps) => {
            const { cartMessage } = this.props.cartObjects;
            if (prevProps.cartObjects.cartMessage != cartMessage) {
                //this.setState({ modalOpened: true, cartMessage: cartMessage });
                this.setState({ modalOpened: cartMessage, cartMessage: cartMessage });
            }
        }

        closeModal = () => {
            this.setState({ modalOpened: false, cartMessage: null });
            this.props.updateCartObjects({ cartMessage: null });
        }

        isEmpty = () => {
            const { itemsCartList } = this.props.cartObjects;
            if (itemsCartList.length === 0) return true;
            return false;
        }

        showMessage = () => {
            const { cartMessage } = this.props.cartObjects;
            const msgObj = ConfigTypes.MESSAGE_OBJ[cartMessage] || null;
            if (msgObj) {
                return (
                    <div className="cartmessage-infoxbox">
                        <div>
                            <h1 className="cartmessage-title">
                                {this.props.intl.formatMessage({ id: msgObj.title })}
                                <span><FontAwesomeIcon icon={msgObj.icon} /></span>
                            </h1>
                            <p className="cartmessage-info">
                                {this.props.intl.formatMessage({ id: msgObj.intl })}
                            </p>
                        </div>
                    </div>
                )
            }
            return null;
        }


        componentDidUpdate(prev) {
            this.initData(prev);
        }

        componentDidMount() {

        }

        render() {
            return (
                <div className="cartmessage">
                    <Modal className="cartmessage-modal" open={this.state.modalOpened}
                        onClose={() => this.setState({ modalOpened: false })}>
                        <div className="cartmessage-close" onClick={this.closeModal}>
                            <FontAwesomeIcon icon={faPlus} />
                        </div>
                        {this.state.cartMessage && this.showMessage()}
                    </Modal>
                </div>)
        }
    }
)

const mapStateToProps = (state) => ({
    cartObjects: state.cart.cartObjects,
    configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(CartMessage))));


